import { useQuery, useQueryClient, useMutation } from 'react-query';
import axios from 'axios';
import { API_PREFIX_URL, CACHE_KEYS } from './config';

const RULESETS_CONTROLLER = 'tap_question_rulesets';

const API = {
  show: async (tapQuestionId, rulesetId) => {
    const showUrl = `${API_PREFIX_URL}/tap_questions/${tapQuestionId}/${RULESETS_CONTROLLER}/${rulesetId}`;
    return await axios.get(showUrl);
  },
  create: async (tapQuestionId, params) => {
    const createUrl = `${API_PREFIX_URL}/tap_questions/${tapQuestionId}/${RULESETS_CONTROLLER}`;
    return await axios.post(createUrl, params);
  },
  update: async (tapQuestionId, rulesetId, params) => {
    const updateUrl = `${API_PREFIX_URL}/tap_questions/${tapQuestionId}/${RULESETS_CONTROLLER}/${rulesetId}`;
    return await axios.put(updateUrl, params);
  },
  destroy: async (tapQuestionId, rulesetId) => {
    const deleteUrl = `${API_PREFIX_URL}/tap_questions/${tapQuestionId}/${RULESETS_CONTROLLER}/${rulesetId}`;
    return await axios.delete(deleteUrl);
  },
};

/*
 *  Show Ruleset
 */
const getRuleset = async (tapQuestionId, rulesetId) => {
  const { data } = await API.show(tapQuestionId, rulesetId);
  return data;
};

export const useRuleset = (tapQuestionId, rulesetId) =>
  useQuery(
    [CACHE_KEYS.RULESETS, rulesetId],
    () => getRuleset(tapQuestionId, rulesetId),
    {
      keepPreviousData: true,
    }
  );

/*
 *  Create Ruleset
 */
const addNewRuleset = async ({ tapQuestionId, ...rest }) => {
  return await API.create(tapQuestionId, rest);
};

export const useAddNewRuleset = () => {
  const queryClient = useQueryClient();
  return useMutation(addNewRuleset, {
    onSuccess: () => {
      queryClient.invalidateQueries(CACHE_KEYS.RULESETS);
    },
  });
};

/*
 *  Update Ruleset
 */
const updateRuleset = async ({ tapQuestionId, rulesetId, ...rest }) => {
  return await API.update(tapQuestionId, rulesetId, rest);
};

export const useUpdateRuleset = () => {
  const queryClient = useQueryClient();
  return useMutation(updateRuleset, {
    onSuccess: (response) => {
      queryClient.invalidateQueries([CACHE_KEYS.RULESETS, response.data.id]);
    },
  });
};

/*
 *  Delete Ruleset
 */
const deleteRuleset = async ({ tapQuestionId, rulesetId }) => {
  return await API.destroy(tapQuestionId, rulesetId);
};

export const useDeleteRuleset = () => {
  const queryClient = useQueryClient();
  return useMutation(deleteRuleset, {
    onSuccess: (response) => {
      queryClient.removeQueries([CACHE_KEYS.RULESETS, response.data.id]);
    },
  });
};
